/**
 * Global Menu Component
 */
window.SLDS = window.SLDS || {};
window.SLDS["global-menu"] = function () {
  return {
    // The modal reads directly from this local method which references the shared global store
    get isOpen() {
      return this.$store.globalMenu.open;
    },

    closeMenu() {
      this.$store.globalMenu.open = false;
    },
  };
};
